import { useGetCustomerDetailsQuery } from "web/features/customer/customerApiSlice";

const useIsPL = () => {
  const { data: customer } = useGetCustomerDetailsQuery();
  const { language } = customer || {};
  return language === "pl_PL";
};

export default useIsPL;
